import { Controller } from 'stimulus';
import events from 'lib/events';
import { getWindowWidth, triggerCustomEvent } from 'lib/helpers';
import SearchStateManager from 'lib/search-state';
import { initTooltips } from 'ez-styles/assets/javascripts/ez-styles/utils/tooltips';

const mobileWidth = 750;
const searchState = new SearchStateManager();

export default class SearchFiltersController extends Controller {
  static targets = ['filterOption'];

  connect() {
    this.setupOffscreenSearchFilters();

    window.addEventListener('resize', this.setupOffscreenSearchFilters);

    window.addEventListener('OpenOffscreenFilters', this.openOffscreenFilters);

    this.setTogglesFromState();

    initTooltips(); // Need to make sure tooltips work every time filters are loaded
  }

  disconnect() {
    window.removeEventListener('resize', this.setupOffscreenSearchFilters);
    window.removeEventListener('OpenOffscreenFilters', this.openOffscreenFilters);
  }

  setTogglesFromState = () => {
    this.finishedLoading = false;

    const activeTogglesFromState = searchState.getRawParamKeys();

    const allFilterInputs = [
      ...this.element.querySelectorAll('.ez-input--checkbox input'),
    ];

    allFilterInputs.forEach((checkbox) => {
      const checkboxFilterParam = checkbox.closest('.ez-input--checkbox').getAttribute('data-filter-param');

      if (activeTogglesFromState.includes(checkboxFilterParam)) {
        checkbox.checked = true; // eslint-disable-line no-param-reassign
      } else {
        checkbox.checked = false; // eslint-disable-line no-param-reassign
      }
    });

    this.finishedLoading = true;
  };

  setFilter = (event) => {
    const thisWrap = event.currentTarget.closest('.ez-input');
    const checkbox = event.currentTarget;
    const param = thisWrap.getAttribute('data-filter-param');

    triggerCustomEvent(events.search.filter, {
      filter: param,
      filterValue: (checkbox.checked ? 1 : 0),
      searchTerm: this.searchTerm,
    });

    if (checkbox.checked === true) {
      searchState.updateParamKey(param);
    } else {
      searchState.removeParamKey(param);
    }

    if (
      checkbox.getAttribute('type') === 'radio'
      && checkbox.checked === false
    ) {
      return;
    }

    if (window.innerWidth > 750) this.applyFilters();
  };

  changeFilter(event) {
    const thisWrap = event.target.closest('.ez-input');
    thisWrap.querySelector('input').click();
  }

  applyFilters() {
    document.body.classList.remove('ez-search-filters--open');
    triggerCustomEvent(events.search.apply_filters);
  }

  setupOffscreenSearchFilters = () => {
    const { body } = document;
    const sidebar = document.querySelector('.search-sidebar--filters');

    if (this.shouldUseMobileFilters()) {
      // If device width is what we would consider "mobile",
      // then set up up offscreen menu stuff for the account pages sub-nav
      if (!body.classList.contains('offscreen-filter-sidebar')) {
        // If we've already set up the offscreen menu, then just ignore this stuff
        body.classList.add('offscreen-filter-sidebar'); // Add the class that makes our sub-nav into an offscreen menu
        sidebar.style.display = 'block'; // Show the menu, now that everything is in place
      }
    } else {
      // If device width is greater than our mobile width,
      // remove all the offscreen controls for the sub-nav and put it back to left-nav layout
      body.classList.remove('offscreen-filter-sidebar');
      body.classList.remove('ez-search-filters--open');
    }
  };

  openOffscreenFilters = () => {
    document.body.classList.add('ez-search-filters--open');
  };

  closeOffscreenFilters = () => {
    document.body.classList.remove('ez-search-filters--open');
  };

  shouldUseMobileFilters() {
    const clientWidth = getWindowWidth(); // Get the current width of the window
    return clientWidth <= mobileWidth;
  }

  get searchForm() {
    return document.querySelector("[data-controller~='search-form']");
  }

  get searchTerm() {
    if (this.searchForm) {
      return this.searchForm.getAttribute('data-search-term');
    }
    return null;
  }
}
